import React from "react";
import { Link } from "gatsby";

export default (props) => (
  <div className="narrative-link-cutout">
    <Link to={`/${props.exhibitReference}/narratives/${props.narrativeReference}`}>
      {props.label}
    </Link>    
  </div>
);